/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
		constructor() {
			super();
			this.mobileMediaQuery = window.matchMedia('(max-width: 767px)');
			this.updateScrollThreshold();
		}

		connectedCallback() {
			this.onScroll = this.checkVisible.bind(this);
			this.onResize = this.updateScrollThreshold.bind(this);

			this.addEventListener('click', this.onClick);
			this.addEventListener('touchstart', this.onClick, {
				passive: true
			});
			window.addEventListener('scroll', this.onScroll, { passive: true });
			window.addEventListener('resize', this.onResize, { passive: true });
			this.mobileMediaQuery.addEventListener('change', this.onScroll);

			this.checkVisible();
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this.onScroll);
			window.removeEventListener('resize', this.onResize);
			this.mobileMediaQuery.removeEventListener('change', this.onScroll);
		}

		updateScrollThreshold() {
			this.scrollThreshold = window.innerHeight;
		}

		checkVisible() {
			window.requestAnimationFrame(() => {
				if (!this.mobileMediaQuery.matches) {
					this.classList.add('back-to-top--active');
					return;
				}

				if (window.scrollY > this.scrollThreshold) {
					this.classList.add('back-to-top--active');
				} else {
					this.classList.remove('back-to-top--active');
				}
			});
		}

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
		}
	}
	customElements.define('back-to-top', BackToTop);
}
